export const codeStatusEnum = Object.freeze({
  available: "available",
  used: "used",
  expired: "expired",
});